import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_GRUPPO } from '../../data.const';
import {
  retrieveGruppoListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteGruppoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_GRUPPO),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ gruppoLoader: true })),
        defer(() =>
          from(
            request({
              path: `gruppo`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            switchMap(() => of(retrieveGruppoListAction(null))),
            catchError(err => {
              console.error(`[epic ${DELETE_GRUPPO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ gruppoLoader: false }))
      );
    })
  );

export default deleteGruppoEpic;
